document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('component-swiper')) {
    class SwiperSlideShow extends HTMLElement {
      constructor() {
        super();
        this.swiperPrev = this.querySelector('.swiper-button-prev');
        this.swiperNext = this.querySelector('.swiper-button-next');
        this.swiperPagination = this.querySelector('.swiper-pagination');
        this.swiperContainer = this.querySelector('.swiper-container');
        this.slideshowSwiper = undefined;
      }
      connectedCallback() {
        if (this.swiperContainer) {
          this.initSwiper(); 
        }
      }
  
      initSwiper() {
        const swiperSettings = JSON.parse(this.getAttribute('data-settings'));
        // console.log(swiperSettings.slidesPerView);
        this.slideshowSwiper = new Swiper(this.swiperContainer, swiperSettings)
      }
  
  
    }
  
    customElements.define('component-swiper', SwiperSlideShow);
  }
})

